import React from 'react';

export const PopoverPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { title, content } = specificAttrs || {};
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
      <button style={{
        padding: '8px 16px',
        background: '#3B82F6',
        color: '#FFFFFF',
        border: 'none',
        borderRadius: '6px',
        fontSize: '14px',
        cursor: 'pointer'
      }}>
        Click me
      </button>
      <div style={{
        position: 'absolute',
        top: '100%',
        left: 0,
        marginTop: '8px',
        padding: '12px',
        background: '#FFFFFF',
        border: '1px solid #E5E7EB',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        minWidth: '200px',
        zIndex: 10
      }}>
        {title && <div style={{ fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>{title}</div>}
        <div style={{ fontSize: '13px', color: '#6B7280' }}>{content || 'Popover content'}</div>
      </div>
      </div>
    </div>
  );
};
